const eur = new Intl.NumberFormat('fr-FR', {
  style: 'currency',
  currency: 'EUR',
  maximumFractionDigits: 0,
});

const eurPrecise = new Intl.NumberFormat('fr-FR', {
  style: 'currency',
  currency: 'EUR',
  maximumFractionDigits: 2,
});

const int = new Intl.NumberFormat('fr-FR');

export const formatCurrency = (value: number, precise = false): string =>
  (precise ? eurPrecise : eur).format(value ?? 0);

export const formatNumber = (value: number): string => int.format(value ?? 0);

export const formatPercent = (value: number, digits = 1): string =>
  `${(value ?? 0).toFixed(digits)}%`;

export const humanizeEvent = (event: string): string =>
  event
    .replace(/^\$/, '')
    .replace(/[_-]+/g, ' ')
    .replace(/\b\w/g, (c) => c.toUpperCase());
